import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { reduxForm, submit, Form, getFormValues } from 'redux-form';
import { injectIntl, FormattedHTMLMessage, intlShape } from 'react-intl';
import ToggleFinancialInstruments, { validateDirectDebit } from '../ToggleFinancialInstruments/ToggleFinancialInstruments';
import PPMarketingTerms from '../../../../../shared-components/PPMarketingTerms/PPMarketingTerms';
import { COMPLETE_FORM_ID } from '../../../../../framework/App/AppConstants';
import { GB_MARKETING_TERMS_MORE_INFO_URL } from '../../../../config/GBConstants';
import { submitCompleteForm } from '../../CAPageActions';
import { spinnerOpen } from '../../../../../framework/components/FullPageSpinner/FullPageSpinnerActions';
import { trackTransition } from '../../../../../framework/store/FPTI/FPTIActions';
import _ from 'lodash';

const LOCALE_PREFIX = 'GB/pages/CAPage/CompletePopup';

export class CompleteForm extends Component {
    static propTypes = {
        showMarketingConsent: PropTypes.bool.isRequired,
        onClickContinue: PropTypes.func.isRequired,
        //to be used when nothing to submit to server
        redirectButton: PropTypes.object.isRequired,
        showDirectDebit: PropTypes.bool.isRequired,
        showDirectDebitError: PropTypes.bool,
        intl: intlShape.isRequired,

        // Provided from decorated reduxForm() component
        handleSubmit: PropTypes.func.isRequired,

        onFormSubmit: PropTypes.func.isRequired,
        formValues: PropTypes.object.isRequired
    };

    constructor(props) {
        super(props);

        this.state = {
            toggleFIOn: false
        };
    }

    getMarketingCheckbox = () => {
        const termsMarketingCheckboxLabel = (
            <FormattedHTMLMessage
                id={`${LOCALE_PREFIX}.agreeToCreditMarketingTerms`}
                className="marketingCheckboxLabel"
                values={{
                    marketingMoreInfoUrl: GB_MARKETING_TERMS_MORE_INFO_URL
                }}
            />
        );
        return <PPMarketingTerms termsCheckboxLabel={termsMarketingCheckboxLabel} />;
    };

    handleToggleFI = () => {
        this.setState({
            toggleFIOn: !this.state.toggleFIOn
        });
    };

    render() {
        const { showMarketingConsent, onClickContinue, redirectButton,
            handleSubmit, onFormSubmit, showDirectDebit, showDirectDebitError, intl } = this.props;
        const { toggleFIOn } = this.state;
        const haveInputs = !showDirectDebitError && (toggleFIOn || showMarketingConsent);

        // use a submit button if we have items that need to be sent to server, otherwise redirect to returnFlow
        const actionButton = haveInputs ? (
            <a href="#"
                data-automation-id="completeSubmit"
                className="btn paypalSuccessConsent full"
                name="completeSubmit"
                onClick={onClickContinue}
                id="completeSubmit"
            >{intl.formatMessage({ id: `${LOCALE_PREFIX}.successContinue` })}
            </a>
        ) : redirectButton;

        return (
            <Form onSubmit={handleSubmit(onFormSubmit)}>
                {
                    showDirectDebit && (
                        <ToggleFinancialInstruments
                            showDirectDebitError={showDirectDebitError}
                            handleToggleFI={this.handleToggleFI}
                            toggleFIOn={toggleFIOn}
                        />
                    )
                }
                {(showMarketingConsent && !showDirectDebitError) && this.getMarketingCheckbox()}
                {actionButton}
            </Form>
        );
    }
}

export const mapStateToProps = state => ({
    formValues : getFormValues(COMPLETE_FORM_ID)(state) || {},
    showDirectDebitError: _.get(state, 'contractPage.showDirectDebitError')
});

export const mapDispatchToProps = dispatch => ({
    onClickContinue() {
        dispatch(submit(COMPLETE_FORM_ID));
    },
    // handleSubmit will call this function when a form submit is triggered
    // formValues are passed by handleSubmit per api specification
    onFormSubmit(formValues) {
        dispatch(spinnerOpen('base.processing'));
        dispatch(submitCompleteForm(formValues));
        dispatch(trackTransition('pp_credit_contractpage', 'completeform_pp_credit_contractpage'));
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(
    reduxForm({
        form: COMPLETE_FORM_ID,
        destroyOnUnmount: false,
        forceUnregisteredOnUnmount: true,
        validate: validateDirectDebit
    })(CompleteForm)
));

